import { Button, Box, Text } from '@fluentui/react-northstar';
import React, { useEffect, useState } from 'react';
import AuthHelper from '../../helper/auth-helper';
import { msalInstance } from '../../helper/AuthContext';
import { Utilities } from '../../helper/Utility';
import { useUserState } from '../../redux/hooks/authenticationHooks';
import { Constants } from '../../helper/constants';
import TokenHelper from '../../helper/tokenHelper';
import { app } from '@microsoft/teams-js';
import { useHistory } from 'react-router-dom';
import { isMobile } from 'react-device-detect';

export const Login: React.FC<{}> = () => {
    localStorage.setItem("origin", window.location.href);
    var componet = localStorage.getItem("origin")!;
    Utilities.LogInfo("Step 1 - Login entered. origin=" + componet + ", isMobile=" + isMobile, "TempLog for debugging");
    var isForceLogin: boolean = componet.indexOf('dulead') > -1;
    var isTopLevelWindow: boolean = (window === window.parent) && (window === window.top);
    Utilities.LogInfo("Step 2 - Flags computed. isForceLogin=" + isForceLogin + ", isTopLevelWindow=" + isTopLevelWindow, "TempLog for debugging");
    if ((isTopLevelWindow && !isMobile) || isForceLogin) {
        Utilities.LogInfo("In browser specific code", "Login.tsx -> Login");
        Utilities.LogInfo("Step 3 - Taking browser/Force branch (web channel)", "TempLog for debugging");
        localStorage.setItem("LoginType", "Force");
        localStorage.setItem("Channel", "web");
        Utilities.LogInfo("Step 4 - LoginType=Force, Channel=web persisted", "TempLog for debugging");
        if (AuthHelper.IsUserLoggedIn()) {
            Utilities.LogInfo("Step 5a - IsUserLoggedIn=true, calling AcquireTokenForResource", "TempLog for debugging");
            AuthHelper.AcquireTokenForResource();
        }
        else {
            Utilities.LogInfo("Step 5b - IsUserLoggedIn=false, clearing MSAL cache and calling loginRedirect", "TempLog for debugging");
            msalInstance["browserStorage"].clear();
            msalInstance.loginRedirect();
        }
        return <Text content="Authenticating..." size="large" />
    }
    else {
        localStorage.setItem("Channel", "IFrame");
        localStorage.setItem("LoginType", "SSO");
        Utilities.LogInfo("In IFrame function", "Login.tsx -> Login");
        Utilities.LogInfo("Step 3 - Taking IFrame/SSO branch. Channel=IFrame, LoginType=SSO, rendering SSOSignIn", "TempLog for debugging");
        return <SSOSignIn />
    }
};

export const LoginButton: React.FC<{}> = () => {
    Utilities.LogInfo("Step X - LoginButton rendered (manual sign-in required)", "TempLog for debugging");
    return <Box style={{ 'padding': '8px' }}>
        <Box>
            <Text content="Please Sign In"></Text>
        </Box>
        <Box style={{ 'paddingTop': '8px' }}>
            <Button primary onClick={AuthHelper.Login} >Sign In</Button>
        </Box>
    </Box>
}

export const SignInStart: React.FC<{}> = () => {
    Utilities.LogInfo("Step 1 - SignInStart page loaded, calling AuthHelper.StartSignIn", "TempLog for debugging");
    AuthHelper.StartSignIn();
    return <Text content="SignIn Start...." size="large" />
}

export const SignInEnd: React.FC<{}> = () => {
    const localstr = localStorage.getItem("origin")!;
    Utilities.LogInfo("Step 1 - SignInEnd page loaded. origin=" + localstr, "TempLog for debugging");
    if (localstr?.indexOf("dulead") > -1) {
        Utilities.LogInfo("Step 2a - dulead origin detected, EndSignIn(autoClose=false, reload=true)", "TempLog for debugging");
        AuthHelper.EndSignIn(false, true, localstr);
    } else {
        Utilities.LogInfo("Step 2b - standard origin, EndSignIn() with defaults", "TempLog for debugging");
        AuthHelper.EndSignIn();
    }
    return <Text content="Sign-In End" size="large" />
}

/**
 * SSO Sign in for TeamsTab
 * @returns
 */
export const SSOSignIn: React.FC<{}> = () => {

    const [isLoginSuccess, setIsLoginSuccess] = useState<boolean>(true);
    const [user, setUser] = useUserState(); //eslint-disable-line @typescript-eslint/no-unused-vars

    Utilities.LogInfo("In SSOSignIn function", "Login.tsx -> SSOSignIn");
    Utilities.LogInfo("In SSOSignIn function", "TempLog for debugging");
    const history = useHistory ();
    useEffect(() => {
        /**
         * Stores the acquired token, hydrates the user state and notifies the Teams host.
         */
        const completeSignIn = (token: string) => {
            Utilities.LogInfo("Step 8 - completeSignIn started. tokenLength=" + token.length, "TempLog for debugging");
            localStorage.setItem("LoginType", "SSO");
            localStorage.setItem(Constants.AccessTokenKey, token);
            Utilities.LogInfo("Step 9 - Access token cached in localStorage under " + Constants.AccessTokenKey, "TempLog for debugging");
            const objUser = TokenHelper.DecodeToken();
            Utilities.LogInfo("Step 10 - Token decoded. enterpriseId=" + objUser?.enterpriseId + ", companyCode=" + objUser?.companyCode + ", careerLevel=" + objUser?.careerLevel, "TempLog for debugging");
            setUser({
                accessToken: token,
                enterpriseId: objUser?.enterpriseId!,
                candidateEnterpriseId: objUser?.enterpriseId!,
                firstName: objUser?.firstName!,
                isAuthenticated: true,
                CorrelationId: objUser?.CorrelationId,
                careerLevel: objUser?.careerLevel,
                companyCode: objUser?.companyCode,
                IsAIGUser: Utilities.IsAIGUser(objUser?.companyCode),
                jobTitle: objUser?.jobTitle,
                personnelNumber: objUser?.personnelNumber,
                location: objUser?.location
            });
            Utilities.LogInfo("Step 11 - Redux user state updated, isAuthenticated=true", "TempLog for debugging");
            app.notifySuccess();
            Utilities.LogInfo("Step 12 - app.notifySuccess() sent to Teams host", "TempLog for debugging");
            setIsLoginSuccess(true);
            Utilities.LogInfo("In SSOSignIn successCallback", "Login.tsx -> SSOSignIn");
            history?.push(window.location.href);
            Utilities.LogInfo("Step 13 - history.push done for " + window.location.href, "TempLog for debugging");
        };

        Utilities.LogInfo("Step 4 - SSOSignIn effect started, requesting Teams context", "TempLog for debugging");
        AuthHelper.GetTeamsContext().then(async (user) => {
            Utilities.LogInfo("Step 5 - Teams context received. loginHint=" + user?.loginHint, "TempLog for debugging");
            let token: string | undefined;
            try {
                await msalInstance.ssoSilent(user!);
                Utilities.LogInfo("Step 6a - msal ssoSilent succeeded", "TempLog for debugging");
                localStorage.setItem("LoginType", "SSO");
                token = await AuthHelper.getRedirectToken(false); //gets token for api
                Utilities.LogInfo("Step 6b - getRedirectToken(false) returned tokenPresent=" + !!token + ", tokenLength=" + (token?.length ?? 0), "TempLog for debugging");
            } catch (error) {
                // ssoSilent cannot work inside the Teams mobile webview (no AAD session in the
                // hidden iframe -> AADSTS50058), so no token is available from MSAL here.
                Utilities.LogError(String(error), "Login.tsx -> SSOSignIn ssoSilent");
                Utilities.LogInfo("Step 6c - MSAL silent path failed: " + String(error), "TempLog for debugging");
            }

            // Fall back to asking the Teams host for the token (works on mobile).
            if (!token) {
                Utilities.LogInfo("Step 7a - No MSAL token, falling back to Teams host token", "TempLog for debugging");
                token = (await AuthHelper.TryGetTeamsSsoToken()) ?? undefined;
                Utilities.LogInfo("Step 7b - Teams host fallback returned tokenPresent=" + !!token + ", tokenLength=" + (token?.length ?? 0), "TempLog for debugging");
            }

            if (token) {
                Utilities.LogInfo("Step 7c - Token available, proceeding to completeSignIn", "TempLog for debugging");
                completeSignIn(token);
                return;
            }

            Utilities.LogInfo("Step 7d - No token from any source, notifying Teams of auth failure", "TempLog for debugging");
            app.notifyFailure({
                reason: app.FailedReason.AuthFailed,
                message: "Unable to acquire an access token for the signed-in user."
            });
            setIsLoginSuccess(false);
            Utilities.LogInfo("Step 7e - isLoginSuccess=false, LoginButton will be rendered", "TempLog for debugging");
        }).catch(error => {
            Utilities.LogError(error, "Login.tsx -> GetTeamsContext SSOSignIn");
            Utilities.LogInfo("Step 5x - GetTeamsContext/flow failed: " + String(error), "TempLog for debugging");
            setIsLoginSuccess(false);
        });
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    return <>{isLoginSuccess ? <h1>SSO SignIn in progress</h1> :
        <LoginButton />}
    </>
}